import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { fontText, fontSize, hexToRgbA, StylesIndexInjections } from 'common-react';
import { TextFieldSize } from './tools/TextField.const';
import { fieldBoxShadow, focusStyle } from '../../styles/mixins';

const textFieldSize = (size?: TextFieldSize) => {
  if (size === TextFieldSize.SMALL) {
    return {
      padding: '8px 16px',
      height: 40,
    }
  }
  return {
    padding: 16,
    height: 56,
  }
}

export default makeUiStyles<Theme, { size?: TextFieldSize, fullWidth?: boolean, helperTextPosition?: 'top' | 'bottom' }>((theme: Theme) => createStyles({
  root: {
    width: props => props.fullWidth ? '100%' : 'auto',
    '&:focus': {
      outline: 'none',
    },
    '& .MuiInputBase-root': {
      borderRadius: 8,
      border: `1px solid ${theme.color.greys[40]}`,
      outline: 'none',
      color: theme.color.greys[80],
      padding: props => textFieldSize(props?.size).padding,
      height: props => textFieldSize(props?.size).height,
      '&.Mui-error': {
        borderColor: theme.color.reds[100],
      },
      '&.Mui-focused': {
        boxShadow: fieldBoxShadow(theme).bs1,
        borderColor: theme.color.greys[80],
        caretColor: theme.color.oranges[50],
      },
      '&.Mui-focusVisible': {
        ...focusStyle(theme),
        boxShadow: 'none',
        borderColor: theme.color.greys[40]
      },
      '&:hover': {
        boxShadow: fieldBoxShadow(theme).bs1,
        outline: 'none',
        borderColor: theme.color.greys[80],
      },
      '&.Mui-disabled': {
        border: `1px solid ${hexToRgbA(theme.color.greys[40], 0.4)}`,
        outline: 'none',
        boxShadow: 'none',
        color: hexToRgbA(theme.color.greys[40], 0.4),
        '& .MuiInputAdornment-root': {
          color: hexToRgbA(theme.color.greys[40], 0.4),
        }
      },
      '& fieldset': {
        top: 0,
        border: 'none',
      },
    },
    '& .MuiInputLabel-root': {
      marginBottom: 8,
    },
    '& .MuiInputBase-input': {
      padding: 0,
      font: fontText('normal', fontSize.base, 24),
      color: 'inherit',
      zIndex: 1,
      height: 'auto',
      '&:-webkit-autofill, &:-webkit-autofill:focus, &:-webkit-autofill:hover': {
        '-webkit-text-fill-color': theme.color.greys[80],
        '-webkit-box-shadow': `0 0 0px 1000px ${theme.color.greys[0]} inset`,
        transition: 'background-color 5000s ease-in-out 0s',
        caretColor: '#191723',
      },
      '&::placeholder': {
        opacity: 1,
        color: theme.color.greys[40],
      },
    },
    '& legend': {
      display: 'none',
    },
    '& .FieldErrorMessage': {
      marginTop: 4,
    },
    '& .FieldHelperText': {
      marginTop: ({ helperTextPosition }) => helperTextPosition === 'top' ? 0 : 8,
      paddingBottom: ({ helperTextPosition }) => helperTextPosition === 'top' ? 8 : 0,
    },
    '& .MuiInputAdornment-root': {
      height: 'auto',
      font: fontText('normal', fontSize.base, 24),
      color: theme.color.greys[60],
    }
  },
}), { name: 'TextField', index: StylesIndexInjections.UI_MOLECULES });
